<template>
  <div class="box3">
    <pageTitle title="学位证书"/>
    <div class="subject-content">
      <div class="banner"></div>
      <div class="item" v-for="(item, index) in items" :key="index">
        <div class="item-title">{{ item.title }}</div>
        <div class="item-text">{{ item.text }}</div>
      </div>
      <vue-seamless-scroll
        :class-option="classOption1"
        class="seamless-warp"
      >
        <div class="demo">
          <div class="item"></div>
        </div>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import vueSeamlessScroll from "vue-seamless-scroll";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    vueSeamlessScroll,
  },
  data() {
    return {
      items: [
        {
          title: "高含金量硕士学位证书",
          text: "毕业可获得全球认可的硕士学位证书，与出国留学所获得的证书一致。", 
        },
        {
          title: "学位证书可多场景使用",
          text: "可用于求职应聘、升职环节、教育背景展示、海外发展等。", 
        },
        {
          title: "学位证书可做各项认证",
          text: "可申请NSC、海牙、大使馆、WES等权威三方国际认证，满足自身证书使用场景需求。", 
        },
      ],
    } 
  },
  computed: {
    classOption1() {
      return {
        step: 0.4, // 数值越大速度滚动越快
        limitMoveNum: 0, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    zixun(name) {
      zhuge.track("H5_美国金门大学专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 80px 0 0;
  width: 100%;
  background: #F7F7F7;
  /deep/.course-title-box .course-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #272020;
    line-height: 64px;
    text-align: center;
  }
  .subject-content {
    margin-top: 48px;
    .banner {
      margin: 0 auto 48px;
      width: 670px;
      height: 552px;
      background: url("../../../assets/coursePage/stevens/box3/banner.png") no-repeat;
      background-size: cover;
    }
    .item {
      font-family: PingFangSC, PingFang SC;
      width: 670px;
      margin: 0 auto ;
      margin-top: 32px;
      .item-title {
        font-weight: bold;
        font-size: 32px;
        color: #272020;
        line-height: 48px;
        text-align: left;
      }
      .item-text {
        margin-top: 8px;
        font-weight: 400;
        font-size: 28px;
        color: #675F5F;
        line-height: 44px;
        text-align: left;
      }
    }
    .item:first-child {
      margin-top: 0; 
    }
    .seamless-warp {
      margin-top: 48px;
      width: 750px;
      height: 504px;
      background: #FFFFFF;
      .item {
        width: 1940px;
        height: 504px;
        background: url("../../../assets/coursePage/illinois/box3/pic.png") no-repeat;
        background-size: cover;
      }
    }
  }
  
}
</style>
